var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoleCountry = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.84 14C24.84 20.2629 19.7629 25.34 13.5 25.34C7.23709 25.34 2.16 20.2629 2.16 14C2.16 7.73709 7.23709 2.66 13.5 2.66C19.7629 2.66 24.84 7.73709 24.84 14ZM27 14C27 21.4558 20.9558 27.5 13.5 27.5C6.04416 27.5 0 21.4558 0 14C0 6.54416 6.04416 0.5 13.5 0.5C20.9558 0.5 27 6.54416 27 14ZM15.4 6.5L16.8 9.22727H21V17.4091H14L12.6 14.6818H9.1V21.5H7V6.5H15.4Z",
    fill: "#767B9B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoleCountry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/role_country.0b2a8ddb64418287952714290ddb83d8.svg";